import apiKeys from '@/modules/api-keys';
import automations from '@/modules/automations';
import blacklists from '@/modules/blacklists';
import checkoutPages from '@/modules/checkout-pages';
import coupons from '@/modules/coupons';
import customers from '@/modules/customers';
import creditMemos from '@/modules/credit-memos';
import customFields from '@/modules/custom-fields';
import dashboard from '@/modules/dashboard';
import dataExports from '@/modules/data-exports';
import gatewayAccounts from '@/modules/gateway-accounts';
import guest from '@/modules/guest';
import guides from '@/modules/guides';
import integrations from '@/modules/integrations';
import invoices from '@/modules/invoices';
import notifications from '@/modules/notifications';
import orders from '@/modules/orders';
import organizations from '@/modules/organizations';
import plans from '@/modules/plans';
import products from '@/modules/products';
import profile from '@/modules/profile';
import rulesEngine from '@/modules/rules-engine';
import segments from '@/modules/segments';
import settings from '@/modules/settings';
import shippingZones from '@/modules/shipping-zones';
import tags from '@/modules/tags';
import transactions from '@/modules/transactions';
import users from '@/modules/users';
import webhooks from '@/modules/webhooks';
import websites from '@/modules/websites';
import search from '@/modules/search';

export const guestModules = [
    ...guest,
];

export const authModules = [
    ...apiKeys,
    ...automations,
    ...blacklists,
    ...checkoutPages,
    ...coupons,
    ...customers,
    ...creditMemos,
    ...customFields,
    ...dashboard,
    ...dataExports,
    ...gatewayAccounts,
    ...guides,
    ...integrations,
    ...invoices,
    ...notifications,
    ...orders,
    ...organizations,
    ...plans,
    ...products,
    ...profile,
    ...rulesEngine,
    ...segments,
    ...settings,
    ...shippingZones,
    ...tags,
    ...transactions,
    ...users,
    ...webhooks,
    ...websites,
    ...search,
];
